import { render, staticRenderFns } from "./MtipomanipulacionGrid.vue?vue&type=template&id=6f2f29fb"
import script from "./MtipomanipulacionGrid.vue?vue&type=script&lang=js"
export * from "./MtipomanipulacionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports